"use client";

import { Sparkles } from "lucide-react";

import { colors } from "@/styles/design-tokens";

export interface MessageAvatarProps {
  isUser: boolean;
  /** Optional initial to display for user avatar. Defaults to "U" if not provided. */
  userInitial?: string;
}

export function MessageAvatar({ isUser, userInitial }: MessageAvatarProps) {
  if (isUser) {
    // getUserInitial already returns a single uppercase character
    const displayInitial = userInitial || "U";
    return (
      <div
        className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-[10px] font-medium text-white sm:h-6 sm:w-6 sm:text-xs"
        style={{ backgroundColor: colors.stroke.pureBlack }}
      >
        {displayInitial}
      </div>
    );
  }
  return (
    <div
      className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full sm:h-6 sm:w-6"
      style={{ backgroundColor: colors.accent.lightestGray }}
    >
      <Sparkles className="h-2.5 w-2.5 sm:h-3 sm:w-3" style={{ color: colors.text.accentMdGray }} />
    </div>
  );
}
